import React, { Component } from 'react';
import { createAndFireEvent, withAnalyticsContext, withAnalyticsEvents, } from '@atlaskit/analytics-next';
import RadioIcon from './RadioIcon';
import { Label, LabelText } from './styled/Radio';
import { HiddenInput, RadioInputWrapper } from './styled/RadioInput';
import { name as packageName, version as packageVersion } from './version.json';
class Radio extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            isHovered: false,
            isFocused: false,
            isActive: false,
            isMouseDown: false,
        };
        this.onBlur = event => {
            this.setState({
                // onBlur is called after onMouseDown if the checkbox was focused, however
                // in this case on blur is called immediately after, and we need to check
                // whether the mouse is down.
                isActive: this.state.isMouseDown && this.state.isActive,
                isFocused: false,
            });
            if (this.props.onBlur) {
                this.props.onBlur(event);
            }
        };
        this.onFocus = event => {
            this.setState({ isFocused: true });
            if (this.props.onFocus) {
                this.props.onFocus(event);
            }
        };
        this.onMouseLeave = event => {
            this.setState({ isActive: false, isHovered: false });
            if (this.props.onMouseLeave) {
                this.props.onMouseLeave(event);
            }
        };
        this.onMouseEnter = event => {
            this.setState({ isHovered: true });
            if (this.props.onMouseEnter) {
                this.props.onMouseEnter(event);
            }
        };
        this.onMouseUp = event => {
            this.setState({ isActive: false, isMouseDown: false });
            if (this.props.onMouseUp) {
                this.props.onMouseUp(event);
            }
        };
        this.onMouseDown = event => {
            this.setState({ isActive: true, isMouseDown: true });
            if (this.props.onMouseDown) {
                this.props.onMouseDown(event);
            }
        };
    }
    render() {
        const { ariaLabel, isDisabled, isRequired, isInvalid, isChecked, label, name, onChange, onInvalid, value, testId, ...rest } = this.props;
        const { isFocused, isHovered, isActive } = this.state;
        return (React.createElement(Label, { isDisabled: isDisabled, onMouseDown: this.onMouseDown, onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave, onMouseUp: this.onMouseUp, "data-testid": testId && `${testId}--radio-label` },
            React.createElement(RadioInputWrapper, null,
                React.createElement(HiddenInput, Object.assign({ "aria-label": ariaLabel, checked: isChecked, disabled: isDisabled, name: name, onChange: onChange, onBlur: this.onBlur, onInvalid: onInvalid, onFocus: this.onFocus, required: isRequired, type: "radio", value: value }, rest, { "data-testid": testId && `${testId}--hidden-radio` })),
                React.createElement(RadioIcon, { isActive: isActive, isChecked: isChecked, isDisabled: isDisabled, isFocused: isFocused, isHovered: isHovered, isInvalid: isInvalid })),
            label ? React.createElement(LabelText, null, label) : null));
    }
}
Radio.defaultProps = {
    isDisabled: false,
    isInvalid: false,
    isChecked: false,
};
const createAndFireEventOnAtlaskit = createAndFireEvent('atlaskit');
export { Radio as RadioWithoutAnalytics };
export default withAnalyticsContext({
    componentName: 'radio',
    packageName,
    packageVersion,
})(withAnalyticsEvents({
    onChange: createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'radio',
        attributes: {
            componentName: 'radio',
            packageName,
            packageVersion,
        },
    }),
})(Radio));
//# sourceMappingURL=Radio.js.map